import React, { useCallback, useEffect, useState } from "react";
import { Tooltip, IconButton } from "@material-ui/core/";
import { CheckCircleOutline } from "@material-ui/icons";
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import LoadingSpinner from "component/LoadingSpinner";
import AlertElement from "component/AlertElement";
import NotAuthorized from "common/NotAuthorized";
import Footer from "page/Home/Footer2";
import Table from "component/Table";
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
import { functions } from "constant";

export default function PaquetesOperados(props) {
  /********** VARIABLES **********/
  const dataOp = props.dataOp;
  const currentUser = props.currentUser;
  const controller = "paquetesDeAfiliacionYAdhesion";
  const [elementAlertModal, setElementAlertModal] = useState({
      titleAlert: "",
      typeAlert: "",
    }),
    [loadingSpinner, setLoadingSpinner] = useState({
      openLoading: false,
      message: "",
    }),
    [openAlertModal, setOpenAlertModal] = useState(false),
    [authorized, setAuthorized] = useState(true),
    [data, setData] = useState([]),
    [tableOptions] = useState({
      filtering: true,
      pageSize: 20,
      pageSizeOptions: [20, 30, 50, 75, 100],
      toolbar: true,
      paging: true,
      search: true,
      actionsColumnIndex: -1,
    }),
    [tableHeader] = useState([
      {
        title: "Identificador del paquete",
        field: "id",
        cellStyle: { width: "100px", height: "50px" },
      },
      { title: "Nombre del paquete", field: "name" },
      { title: "Hojas en el paquete", field: "totalHojas" },
      { title: "Fecha de creación", field: "fechaCreacionParseada" },
      { title: "Fecha de envío", field: "fechaEnviado" },
      { title: "Fecha de resolución", field: "fechaResolucion" },
      {
        title: "Estado",
        field: "estado",
        filtering: false,
        render: () => (
          <div style={{ minWidth: "200px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutline style={{ color: "#52be80" }} /> PAQUETE
              OPERADO
            </div>
          </div>
        ),
      },
      {
        title: "Documentos",
        field: "acciones",
        filtering: false,
        render: (rowData) => (
          <div style={{ minWidth: "200px" }}>
            <Tooltip title="Descargar Reporte">
              <IconButton
                size="small"
                color="primary"
                onClick={() => dowloadReport(rowData)}
              >
                <img
                  alt="dowload"
                  style={{ height: 40, width: 40 }}
                  src="/assets/constancia_dowload.svg"
                />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    ]);
    
  /********** FUNCTIONS **********/
  /*  Este método lista la información de los paquetes con esta 4 - Finalizado y que sean de faseOP 3 - Partido Político
        se ejecuta en el useEffect y en el "refreshList"   */
  const showList = useCallback(async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Obteniendo paquetes operados...",
    });
    try {
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "list"
      );
      if (hasPermission.error) {
        setAuthorized(false);
        Alert.warning("Permisos Insuficientes");
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      } else {
        let response = await ApiServices[controller].getListPackageOp(
          dataOp.idOrganizacion,
          3,
          3
        );
        let data = [];
        if (response.error !== null) {
          setOpenAlertModal(true);
          setElementAlertModal({
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          data = response.data;
          data.forEach((value) => {
            value.movimientos.reduce((acc, movimiento) => {
              switch (movimiento.idEstadoPaquete) {
                case 0:
                  if (!acc.fechaCreacionParseada) {
                    acc.fechaCreacionParseada =
                      movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
                case 1:
                  if (!acc.fechaEnviado) {
                    acc.fechaEnviado = movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
                case 4:
                  if (!acc.fechaResolucion) {
                    acc.fechaResolucion =
                      movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
              }
              return acc;
            }, value);
          });

          setData(data);
        }
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: false,
      });
    }
  }, []);

  useEffect(() => {
    showList();
  }, [showList]);

  /*  Este método ejecuta la función para descargar un documento pdf con el cve de cada paquete,
        se ejecuta desde el icono "Descargar Reporte" */
  const dowloadReport = async (data) => {
    var idPackage = data.id;
    const sendData = {
      idOp: dataOp.idOrganizacion,
      idPaquete: idPackage,
      nombreOp: dataOp.name,
      siglas: dataOp.siglas,
      usuarioSolicita: currentUser.userName
    };
    try {
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: true,
        message: "Generando reporte...",
      });
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "reporte"
      );
      if (hasPermission.error) {
        Alert.warning("Permisos Insuficientes");
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      } else {
        let response =
          await ApiServices.paquetesDeAfiliacionYAdhesion.generarReporte(sendData);
        if (response.error !== null) {
          setOpenAlertModal(true);
          setElementAlertModal({
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          functions.downloadPDFFromStringBase64(
            response.data,
            "Reporte General Paquete " + idPackage
          );
        }
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: false,
      });
    }
  };

  /* Este método cierra el modal "AlertElement" de mensajes de alerta */
  const handCloseModal = () => {
    setOpenAlertModal(false);
  };

  /********** RENDER **********/
  if (!authorized) {
    return <NotAuthorized />;
  }

  return (
    <div>
      {loadingSpinner && (
        <LoadingSpinner
          open={loadingSpinner.openLoading}
          message={loadingSpinner.message}
        />
      )}
      {openAlertModal && (
        <AlertElement
          typeAlert={elementAlertModal.typeAlert}
          openModal={openAlertModal}
          title={elementAlertModal.titleAlert}
          handCloseModal={handCloseModal}
        />
      )}
      <Table
        title={"Listado de paquetes"}
        header={tableHeader}
        data={data}
        refreshList={showList}
        options={tableOptions}
      />
      <Footer />
    </div>
  );
}
